$(document).click(function (event) {
  // outside of dropdown list
  if (
    !$(event.target).parent().hasClass('dropdown-list') &&
    $(event.target).parents('.start-date-dropdown-input').length == 0
  ) {
    $('.dropdown-list').addClass('hidden').removeClass('block')
  }
})
